package com.routexk.quiz.i18n

import androidx.compose.runtime.mutableStateOf
import com.routexk.quiz.utils.Storage
import kotlinx.browser.window

enum class Lang { EN, ES }

/**
 * Tiny reactive i18n layer. The current language is a Compose state, so any
 * composable that reads a localized string (via [t]) recomposes when it changes.
 * Initial language: ?lang= override → stored choice → browser language (es* → ES).
 */
object I18n {
    private const val KEY = "app_lang"

    private val state = mutableStateOf(detectInitial())

    var lang: Lang
        get() = state.value
        set(value) {
            state.value = value
            Storage.save(KEY, value.name)
        }

    private fun detectInitial(): Lang {
        urlLang()?.let { Storage.save(KEY, it.name); return it }
        Storage.get(KEY)?.let { s -> Lang.entries.firstOrNull { it.name == s }?.let { return it } }
        val nav = (window.navigator.language ?: "").lowercase()
        return if (nav.startsWith("es")) Lang.ES else Lang.EN
    }

    private fun urlLang(): Lang? {
        val v = window.location.search.removePrefix("?")
            .split("&")
            .firstOrNull { it.startsWith("lang=") }
            ?.substringAfter("=")
            ?.lowercase()
        return when (v) {
            "es" -> Lang.ES
            "en" -> Lang.EN
            else -> null
        }
    }
}

/** Current-language string. Reactive when read inside composition. */
fun t(en: String, es: String): String = when (I18n.lang) {
    Lang.EN -> en
    Lang.ES -> es
}

/** Current-language value of any type (e.g. a List<String> of options). */
fun <T> tv(en: T, es: T): T = when (I18n.lang) {
    Lang.EN -> en
    Lang.ES -> es
}
